<template>
  <div>
    <wc-section-title title='Schedule'></wc-section-title>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'schedule-base',
  computed: {
    menu () {
      return [
        {
          title: 'Schedule Dashboard',
          icon: this.$store.state.icons.modules.schedule.icon,
          route: { name: 'ScheduleDashboard' }
        }
      ]
    }
  },
  mounted () {
    this.$store.dispatch('loadMainMenuTitle', 'Schedule Menu')
    this.$store.dispatch('loadMainMenu', this.menu)
  }
}
</script>
